import { DateRange } from '@mui/x-date-pickers-pro';
import { createSlice } from '@reduxjs/toolkit';

import { Location } from '../ellipsisApi';
import { RootState } from '../store';

interface UIState {
  homeSearch: {
    selectedTab: number;
    location: (Location | null)[];
    date: DateRange<Date>;
    category: string[];
  } | null;
  actionNotification: {
    show: boolean;
    notification: {
      title: string;
      description: string;
    };
  } | null;
}

const initialState: UIState = {
  homeSearch: null,
  actionNotification: null,
};

const ui = createSlice({
  name: 'ui',
  initialState: initialState,
  reducers: {
    addActionNotification: (state, action) => {
      state.actionNotification = action.payload;
    },
    removeActionNotification: (state) => {
      state.actionNotification = null;
    },
    setHomeSearchStatus: (state, action) => {
      if (action.payload && action.payload.date) {
        // Add type assertion for date property
        action.payload.date = action.payload.date as any;
      }
      state.homeSearch = action.payload;
    },
  },
});

export const selectHomeSearch = (state: RootState) => state.ui.homeSearch;

export default ui;
